import { defaultFilters } from "@nextories/vue-tasks/src/store/tasksStore";
import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore";
import { useAuthStore } from "@nextories/vue-tasks/src/store/authStore";
import { cloneWithoutReactivity } from "@nextories/vue-core-components/src/store/common";
import filterHelper from '@nextories/vue-tasks/src/utils/helpers/common/filter';
import tasksHelper from '@nextories/vue-tasks/src/utils/helpers/tasks';
import { i18n } from "@/plugins/i18n";
import type { FilterQuery } from "@nextories/vue-tasks/src/types/Filters";

export const pluginTasksStore = {
  actions: {
    setInitialFilters(query?: FilterQuery) {
      const { listTasksType } = this;
      // Initialize subFilters with deep-cloned values
      this.subFilters = {
        ...cloneWithoutReactivity(listTasksType),
        ...tasksHelper.statusDgtFilter(i18n.global.tm('project.shortStatus')),
        ...defaultFilters,
      };
      // Set base filters
      this.setBaseMainFilters(query);
      const mainFilters = this.baseMainFilters;
      const filterUsers = useUsersStore().$state.filterUsers;
      const { myTasks } = filterUsers;
      // Update 'myTasks' title if defined
      if (myTasks) {
        myTasks.title = i18n.global.t('base.myProjectsTasks');
      }
      const currentUser = useAuthStore().$state.currentUser;
      // Handle 'notAssignedUser' based on admin status
      if (currentUser && currentUser.is_admin) {
        mainFilters.notAssignedUser = {
          ...mainFilters.notAssignedUser,
          subFilters: {
            ...this.subFilters,
            ...filterHelper.formatDatesFilter('dateDue', 'date_due'),
            ...cloneWithoutReactivity(tasksHelper.directionFilter()),
          },
        };
      } else {
        delete mainFilters.notAssignedUser;
      }
      // Merge filterUsers with subFilters
      this.subFilters = {
        ...cloneWithoutReactivity(filterUsers),
        ...this.subFilters,
      };
      const todaySubFilters = this.subFilters ? cloneWithoutReactivity(this.subFilters) : {};
      const disputeSubFilters = todaySubFilters.dispute ? cloneWithoutReactivity(todaySubFilters.dispute) : {};
      delete todaySubFilters.dispute;
      // Update 'today' filter with deep-cloned and formatted data
      mainFilters.today = {
        ...mainFilters.today,
        subFilters: {
          ...todaySubFilters,
          ...cloneWithoutReactivity(this.pastTasks),
          dispute: disputeSubFilters,
          ...cloneWithoutReactivity(tasksHelper.directionFilter()),
          ...filterHelper.setSubFilterEnabled('today', myTasks, query),
        },
      };
      // Update 'allTasks' filter
      mainFilters.allTasks = {
        ...mainFilters.allTasks,
        subFilters: {
          ...this.subFilters,
          ...filterHelper.formatDatesFilter('dateDue', 'date_due'),
          ...cloneWithoutReactivity(tasksHelper.directionFilter()),
        },
      };
      // Update 'inbound' filter
      mainFilters.inbound = {
        ...mainFilters.inbound,
        ...this.mainSettings,
        id: 'inbound',
        query: {
          contact_id: 'Inbound',
          status: this.listStatusAvailable,
          date_due: {
            maxDate: { type: 'day' },
            isSame: true,
          },
        },
        subFilters: {
          ...this.subFilters,
          ...filterHelper.setSubFilterEnabled('inbound', myTasks, query),
        },
      };
      // Update 'clientRequest' filter
      mainFilters.clientRequest = {
        ...mainFilters.clientRequest,
        ...this.mainSettings,
        subFilters: {
          ...cloneWithoutReactivity(filterUsers),
          ...tasksHelper.statusDgtFilter(i18n.global.tm('project.shortStatus')),
          ...defaultFilters,
          ...filterHelper.setSubFilterEnabled('clientRequest', myTasks, query),
        },
      };
      // Set the final filters after processing all main filters
      this.setMainFilters(cloneWithoutReactivity(filterHelper.setOrderMainFilters(mainFilters)));
    },
  },
};
